export default "__VITE_PUBLIC_ASSET__97f39394__"